// 交易类型
export const TXN_TYPE = {
  /** Sale */
  SALE: '0006',

  /** 代理商分润 */
  AGENCY_PROFIT: '0067',

  /** 税费 */
  TAX: '0030',

  /** 调账 */
  ADJUSTMENT: '0099',

  /** 费用 */
  FEE: '0098',

  /** 授权 */
  AUTHORIZATION: '0008',

  /** 绑卡 */
  BIND_CARD: '0040',

  /** 预授权 */
  PRE_AUTHORIZATION: '0009',

  /** Capture */
  CAPTURE: '0010',

  /** Void */
  VOID: '0011',

  /** 交易撤销 */
  TRANSACTION_CANCEL: '0029',

  /** 退款 */
  REFUND: '0005',

  /** 3DS */
  THREE_DS: '3DS',

  /** 拒付 */
  CHARGEBACK: '0018',

  /** 拒付撤销 */
  CHARGEBACK_REVERSAL: '0019',

  /** 拒付作废 */
  CHARGEBACK_VOID: '0020',

  /** 拒付申诉 */
  CHARGEBACK_APPEAL: '0022',

  /** 拒付申诉成功 */
  CHARGEBACK_APPEAL_SUCCESS: '0023',

  /** 二次拒付申诉 */
  SECOND_CHARGEBACK_APPEAL: '0025',

  /** 二次拒付申诉成功 */
  SECOND_CHARGEBACK_APPEAL_SUCCESS: '0026',

  /** 二次拒付申诉失败 */
  SECOND_CHARGEBACK_APPEAL_FAILURE: '0027',

  /** DEPOSIT_REL */
  DEPOSIT_REL: '0013',

  /** 月费 */
  MONTHLY_FEE: '0034',

  /** 出款手续费 */
  WITHDRAWAL_FEE: '0035',

  /** 费用调整 */
  FEE_ADJUSTMENT: '0036',

  /** 入账手续费 */
  DEPOSIT_FEE: '0049',

  /** 入账 */
  DEPOSIT: '0001',

  /** 固定保证金 */
  FIXED_DEPOSIT: '0056',

  /** 网站接入费 */
  WEBSITE_ACCESS_FEE: '0060',

  /** 固定保证金释放 */
  FIXED_DEPOSIT_RELEASE: '0057',

  /** 分账 */
  PROFIT_SHARING: '0063',

  /** 分账回退 */
  PROFIT_SHARING_REFUND: '0064',

  /** 跨境费 */
  CROSS_BORDER_FEE: '0062',
};
